import SummaryPlanInfoBox from './SummaryPlanInfoBox'

export default SummaryPlanInfoBox
